<template>
    <div class="vh-100 main-frame payment-result-bg">
        <div class="shade-layer text-center pt-5">
            <p class="icon-size mt-2 mb-0"><i class="bi bi-info-circle-fill"></i></p>
            <p class="fw-bold fs-2">{{ $t('paymentUnfinished.title') }}</p>
            <p class="mx-4">{{ $t('paymentUnfinished.message') }}</p>
            <button class="btn btn-dark" @click="returnToTransaction">{{ $t('paymentUnfinished.backToTransactions') }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaymentUnfinished",
        methods: {
            returnToTransaction(){
                this.$router.replace('/transactions')
            }
        }
    }
</script>

<style scoped>
.main-frame {
  background-image: url('../../public/img/undraw_family_vg76.svg');
}

.icon-size {
  font-size: 3rem;
}

.shade-layer {
  background: linear-gradient(135deg, rgba(var(--color-warning-rgb), 0.7), rgba(210, 210, 207, 0.7));
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
